module.exports = __webpack_public_path__ + "static/media/plus.7c088258.svg";